import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SlArrowDown } from "react-icons/sl";
import { SlArrowUp } from "react-icons/sl";
import axiosInstance from "../../Services/axios";
import { RiDeleteBin5Line } from "react-icons/ri";
import OfferCard from "./offercard";
import ReactLoading from "react-loading";
import p_vendor_map from "../../Assets/Images/p_vendor_map.svg"
import { GoDotFill } from "react-icons/go";
import { useSelector } from "react-redux";
import { fetchVendorOfferDetails, fetchVendorOfferPriceDetails } from "../../Services/api";
import { showToast } from "../../Components/toastConfig/ToastConfig";

const Singleofferdetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  const { from_Page } = location.state || {};
  const [offerdetails, setOfferdetails] = useState('');
  const [showContentBI, setShowContentBI] = useState(true);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [offertime, setOffertime] = useState([]);
  const [showstore, setShowstore] = useState(true);
  const [showdoorstep, setDoorstep] = useState(true);
  const [showproduct, setShowproduct] = useState(true);
  const [storeservice, setStoreservice] = useState([]);
  const [doorstepservice, setDoorstepservice] = useState([]);
  const [product, setProduct] = useState([]);
  const [buyServices, setBuyServices] = useState([]);
  const [getServices, setGetServices] = useState([]);
  const [buydoorServices, setBuydoorServices] = useState([]);
  const [getdoorServices, setGetdoorServices] = useState([]);
  const [buyProduct, setBuyProduct] = useState([]);
  const [getProduct, setGetProduct] = useState([]);
  const [data, setData] = useState()
  const [vendor, setVendor] = useState()
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMgs, setModalMgs] = useState('')
  // const dateOptions = { year: "numeric", month: "short", day: "numeric" };
  let { vendorId, offerid } = useParams();

  useEffect(() => {
    offerdetail();
    OfferProduct();

  }, []);

  function openMap(lat, lng) {
    const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(mapsUrl, '_blank');
  }
  // const terms = termsAndConditions.split('•').filter(term => term.trim().length > 0);
  const offerdetail = async () => {
    try {
      let reqData = {
        vendor_id: vendorId,
        offer_id: offerid,
      };

      let res = await fetchVendorOfferDetails(reqData)
      if (res?.status == 200) {
        setVendor(res.data.vendor_details)
        setOfferdetails(res.data.offer_detail);
        setOffertime(res.data.offer_detail.offer_availability);
        setPageLoaded(true);
        localStorage.removeItem('serviceDetail');
        localStorage.removeItem('serviceAdded');
        localStorage.removeItem('productAdded');
        localStorage.removeItem('localStorageserviceTime');
      };
    } catch (err) {
      if (err.response.status == 400 || err.response.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };

  const OfferProduct = async () => {
    try {
      let reqData = {
        vendor_id: vendorId,
        offer_id: offerid,
      };

      // offer-price-detail returns offer_Details (buy/get products, services and prices)
      let res = await fetchVendorOfferPriceDetails(reqData);
      if (res?.status == 200) {
        let data = res.data;
        setData(data);
        setStoreservice(data.offer_Details.services_name);
        setDoorstepservice(data.offer_Details.doorstep_services_name);
        setProduct(data.offer_Details.products_name);
        setBuyServices(data.offer_Details.buy_services_name);
        setGetServices(data.offer_Details.get_services_name);
        setBuydoorServices(data.offer_Details.buy_doorstep_services_name);
        setGetdoorServices(data.offer_Details.get_doorstep_services_name);
        setBuyProduct(data.offer_Details.buy_product_name);
        setGetProduct(data.offer_Details.get_product_name);
        localStorage.removeItem('serviceDetail');
        localStorage.removeItem('serviceAdded');
        localStorage.removeItem('productAdded');
        localStorage.removeItem('localStorageserviceTime');
      };
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        showToast(err.response || "Something went wrong, please try again later", "error");
      }
    }
  };



  const totalProductPrice = product.reduce((accumulator, product) => {
    return accumulator + parseFloat(product.product_price);
  }, 0);

  const totalServicePrice = storeservice.reduce((total, storeservice) => {
    return total + parseFloat(storeservice.service_price);
  }, 0);

  const totalDoorServicePrice = doorstepservice.reduce((total, item) => {
    return total + parseFloat(item.doorstep_price);
  }, 0);

  const totalBuyservicePrice = buyServices.reduce((cost, buyServices) => {
    return cost + parseFloat(buyServices.service_price);
  }, 0);

  const totalGetservicePrice = getServices.reduce((cost, getServices) => {
    return cost + parseFloat(getServices.service_price);
  }, 0);

  const totalBuydoorservicePrice = buydoorServices.reduce((costs, buydoorServices) => {
    return costs + parseFloat(buydoorServices.doorstep_price);
  },
    0
  );
  const totalGetdoorservicePrice = getdoorServices.reduce((costs, index) => {
    return costs + parseFloat(index.doorstep_price);
  }, 0);
  const totalBuyProductPrice = buyProduct.reduce((costs, index) => {
    return costs + parseFloat(index.product_price) * index.count;
  }, 0);
  const totalGetProductPrice = getProduct.reduce((total, product) => {
    return total + parseFloat(product.product_price) * product.count;
  }, 0);



  const toggleContentBI = () => {
    setShowContentBI(!showContentBI);
  };
  const togglestore = () => {
    setShowstore(!showstore);
  };
  const toggledoorstep = () => {
    setDoorstep(!showdoorstep);
  };
  const toggleproduct = () => {
    setShowproduct(!showproduct);
  };

  const duration = "15-12-2024";

  const [day, month, year] = duration.split("-");


  const formattedDate = new Date(`${year}-${month}-${day}`);


  const dateOptions = { year: "numeric", month: "short", day: "numeric" };
  const formattedDateString = new Intl.DateTimeFormat("en-US", dateOptions).format(formattedDate);

  const [monthName, dayNum, yearNum] = formattedDateString.split(" ");
  const customFormat = `${monthName} ${dayNum} ${yearNum}`;

  // The expiry date is inclusive: the offer stays valid until 23:59:59.999 IST on that date.
  const getOfferExpiryEnd = (duration) => {
    if (!duration) return null;

    let ymd;
    if (duration.includes("T")) {
      const parsed = new Date(duration);
      if (Number.isNaN(parsed.getTime())) return null;
      const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).formatToParts(parsed);
      const map = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      ymd = `${map.year}-${map.month}-${map.day}`;
    } else {
      const segments = duration.split("-");
      if (segments.length !== 3) return null;
      const [day, month, year] = segments[0].length === 4 ? [segments[2], segments[1], segments[0]] : segments;
      ymd = `${year}-${month}-${day}`;
    }

    const expiryEnd = new Date(`${ymd}T23:59:59.999+05:30`);
    return Number.isNaN(expiryEnd.getTime()) ? null : expiryEnd;
  };

  // Buy & Get (type 3): every buy/get product must be in stock for the quantity the offer needs.
  // Combo / Pick any combo (type 4): at least `combo_count` of the offer's products must be in stock.
  // Other offer types are not checked here.
  const getOutOfStockMessage = () => {
    const detail = data?.offer_Details;
    if (!detail) return '';

    let unavailable = [];
    if (offerdetails?.offer_type == 3) {
      unavailable = [...(detail.buy_product_name || []), ...(detail.get_product_name || [])].filter((p) => p?.out_of_stock);
    } else if (offerdetails?.offer_type == 4) {
      const items = detail.products_name || [];
      const needed = Number(offerdetails?.combo_count) || items.length;
      const inStock = items.filter((p) => !p?.out_of_stock).length;
      unavailable = items.length > 0 && inStock < needed ? items.filter((p) => p?.out_of_stock) : [];
    }

    const names = Array.from(new Set(unavailable.map((p) => `'${String(p?.product_name || '').trim()}'`)));
    if (names.length === 0) return '';
    return `${names.join(', ')} ${names.length > 1 ? 'are' : 'is'} out of stock right now, so click the button below to search for other offers.`;
  };
  const outOfStockMessage = getOutOfStockMessage();

  const expireDate = getOfferExpiryEnd(offerdetails?.duration);
  const today = new Date();

  console.log()
  useEffect(() => {
    let fixNavigation = localStorage.getItem('fromPage');

    if (fixNavigation == 'fromLink') {
      navigate(`/vendor/${vendorId}`);
    }
    if (vendor?.offers_status == 0) {
      setModalMgs('Offers are currently unavailable. The merchant has disabled offers for this store.');
      setModalOpen(true)
    }
    if (expireDate && expireDate < today) {
      setModalMgs('This offer is no longer valid. Click the button below to search for other offers!');
      setModalOpen(true)
    }
    else if (((Number(offerdetails.offer_used_count ?? 0) >= Number(offerdetails.usage_limit_per_user)) ||
      (offerdetails.usage_limit_status == "1" && Number(offerdetails.usage_limit) == 0)
    )) {
      setModalMgs('Offer limit reached, so click the button below to search for other offers.');
      setModalOpen(true);
    }
    else if (offerdetails.status == 2) {
      setModalMgs('This offer is currently inactive. Please contact the merchant for assistance.')
      setModalOpen(true)

    }
    else if (outOfStockMessage) {
      setModalMgs(outOfStockMessage)
      setModalOpen(true)
    }

  }, [data, offerdetails, outOfStockMessage])

  const handelNavigate = (type) => {
    if (type == 2) {
      if (vendor?.offers_status == 0) {
        navigate(`/vendor/${vendorId}`);
      } else {
        navigate(`/Offerlist/${data?.vendor_id}`)
        localStorage.setItem('fromPage', 'fromLink')
      }
    }
    else if (type == 1) {
      if (expireDate && expireDate < today) {
        setModalMgs('This offer is no longer valid. Click the button below to search for other offers!');
        setModalOpen(true)
      }
      else if (((Number(offerdetails.offer_used_count ?? 0) >= Number(offerdetails.usage_limit_per_user)) ||
        (offerdetails.usage_limit_status == "1" && Number(offerdetails.usage_limit) == 0)
      )
      ) {
        setModalMgs('Offer limit reached, so click the button below to search for other offers.');
        setModalOpen(true);
      }
      else if (offerdetails.status == 2) {
        setModalMgs('This offer is currently inactive. Please contact the merchant for assistance.')
        setModalOpen(true)

      }
      else if (outOfStockMessage) {
        setModalMgs(outOfStockMessage)
        setModalOpen(true)
      }
      else if (offerdetails.status == 1) {
        navigate(`/book-now/${vendorId}`, {
          state: { vendorId, applyid: offerdetails.applied_to, offerid, offertype: offerdetails?.offer_type, categoryStatus: offerdetails?.applied_to_status, offerdetails }
        })
      }
    }

  }



  const calculateDiscount = (total, discount, discountType) => {
    const totalAmt = Number(total) || 0;
    const discountAmt = Number(discount) || 0;

    if (totalAmt <= 0 || discountAmt <= 0) {
      return { savedAmount: "0.00", finalPrice: totalAmt?.toFixed(2) };
    }

    let savedAmount = 0;

    if (discountType == "1") {
      savedAmount = discountAmt;
    } else if (discountType == "2") {
      savedAmount = (totalAmt * discountAmt) / 100;
    }

    const finalPrice = totalAmt - savedAmount;

    return {
      savedAmount: savedAmount?.toFixed(2),
      finalPrice: Math.floor(finalPrice)?.toFixed(2),
    };
  };


  const { savedAmount, finalPrice } = calculateDiscount(
    totalServicePrice,
    offerdetails?.discount,
    offerdetails?.discount_type
  );

  const { savedAmount: savedDoorAmt, finalPrice: finalDoorPrice } = calculateDiscount(totalDoorServicePrice, offerdetails?.discount, offerdetails?.discount_type);


  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button"
            onClick={() =>
              from_Page == "serarch_offer" ?
                navigate('/search-store ', { state: { from_Page: "offers" } }) :
                navigate(`/Offerlist/${data?.vendor_id || vendorId}`)}

          />

          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
            Offer Details
          </div>
        </div>
      </div>

      {pageLoaded ? (
        <div>
          <div className="scroller-style-y bg-white">
            <div className="mb-2 mt-2 ">{offerdetails ? <OfferCard data={offerdetails} offer_from_Page="offerDetails" /> : <></>}</div>
            <div className="mt-3">
              <hr></hr>
              <div className="p-3">
                <div className="m-0">
                  <h5 className="ff-poppins-semiBold fs-15"> {offerdetails.offer_name}{" "} </h5>
                  {offerdetails?.offer_type == "4" ? (
                    <p className="m-0 fs-13 ff-poppins-semiBold primary-text">
                      Pick any {offerdetails.combo_count} at <span className="rupeeIcon "> ₹</span>{offerdetails?.offer_price} combo offer
                    </p>
                  ) : (
                    ["1", "2", "3"].includes(String(offerdetails?.offer_type)) && (
                      <h6 className="ff-poppins-semiBold fs-14 primary-text">
                        {offerdetails?.offer_type == "3" ? "Buy & Get" : "Get"}{" "}
                        {offerdetails?.discount_type == "1" && <span className="rupeeIcon "> ₹</span>}{offerdetails?.discount}
                        <span>{offerdetails?.discount_type == "2" ? "%" : ""}</span>{" "}

                        Offer
                      </h6>
                    )
                  )}


                  <p className="ff-poppins-regular fs-12 m-0 mt-1">{offerdetails?.offer_description} </p>
                  <div className="d-flex justify-content-between mt-4 " onClick={toggleContentBI} style={{ cursor: 'pointer' }} >
                    <div>
                      <h6 className="primary-text fs-15 ff-poppins-bold"> Offer Information </h6>
                    </div>
                    <div>
                      {showContentBI ? (
                        <SlArrowUp className="me-2" />
                      ) : (
                        <SlArrowDown className="me-2" />
                      )}
                    </div>
                  </div>
                  {showContentBI && (
                    <div>
                      {
                        // General Offer
                        offerdetails?.offer_type == "1" ? (
                          <div>
                            <div>
                              {(
                                (offerdetails?.applied_to === '1') || (offerdetails?.applied_to === '2,1') || (offerdetails?.applied_to === '1,2')) && (
                                  <div>
                                    {storeservice.length > 0 &&
                                      <>
                                        <div className="d-flex justify-content-between mt-4 " onClick={togglestore}>
                                          <h6 className=" fs-15 ff-poppins-semiBold">Store Services included</h6>
                                          <div>
                                            {showstore ? (
                                              <SlArrowUp className="me-2" />
                                            ) : (
                                              <SlArrowDown className="me-2" />
                                            )}
                                          </div>
                                        </div>
                                        {/* Store modle */}
                                        {showstore && (
                                          storeservice.map((service, index) => (
                                            <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                              <span>{service.service_name}</span>
                                              <span>{service.service_price}.00</span>
                                            </div>
                                          ))
                                        )}

                                      </>}
                                    {doorstepservice.length > 0 &&
                                      <>
                                        <div className="d-flex justify-content-between mt-4 " onClick={toggledoorstep}>
                                          <h6 className=" fs-15 ff-poppins-semiBold"> Doorstep Services included </h6>
                                          <div>
                                            {showdoorstep ? (
                                              <SlArrowUp className="me-2" />
                                            ) : (
                                              <SlArrowDown className="me-2" />
                                            )}
                                          </div>
                                        </div>
                                        {showdoorstep && (
                                          doorstepservice.map((service, index) => (
                                            <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                              <span>{service.service_name}</span>
                                              <span>{service.doorstep_price}.00</span>
                                            </div>
                                          ))
                                        )}
                                      </>}
                                  </div>
                                )}


                              {((offerdetails?.applied_to === '2' || offerdetails?.applied_to === '2,1' || offerdetails?.applied_to === '1,2') && product.length > 0) && (
                                <div>
                                  <div className="d-flex justify-content-between mt-4 " onClick={toggleproduct}>
                                    <h6 className=" fs-15 ff-poppins-semiBold"> Products </h6>
                                    <div>
                                      {showproduct ? (
                                        <SlArrowUp className="me-2" />
                                      ) : (
                                        <SlArrowDown className="me-2" />
                                      )}
                                    </div>
                                  </div>
                                  {showproduct && (
                                    product.map((item, index) => (
                                      <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                        <span>{item.product_name}</span>
                                        <span>{item.product_price}.00</span>
                                      </div>
                                    ))
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )


                          : // Combo offer 
                          offerdetails?.offer_type == "2" ?

                            offerdetails.applied_to == "2" ? (
                              <div>
                                <div className="d-flex justify-content-between mt-4 " onClick={toggleproduct} >
                                  <h6 className=" fs-15 ff-poppins-bold"> Products </h6>

                                  <div>
                                    {showproduct ? (
                                      <SlArrowUp className="me-2" />
                                    ) : (
                                      <SlArrowDown className="me-2" />
                                    )}
                                  </div>
                                </div>
                                {showproduct &&
                                  product.map((item, index) => {
                                    return (
                                      <div className='offerServiceProduct ' key={index}>
                                        <span>{item.product_name}</span> <span>{item.product_price}.00</span>
                                      </div>
                                    );
                                  })}

                                <div className="mt-3">
                                  <div className="offerServiceProduct">
                                    <span >Subtotal</span>
                                    <span >{totalProductPrice}.00 </span>
                                  </div>
                                  <div className="totalBar primary-text  fs-12 ff-poppins-medium d-flex justify-content-between p-1 mt-1">
                                    <span className="">
                                      Saved by offer ( {offerdetails?.discount_type == "1" ? `₹${offerdetails?.discount}`
                                        : offerdetails?.discount_type == "2" ? `${offerdetails?.discount}%` : ""} )
                                    </span>
                                    <span>
                                      Rs.{offerdetails?.discount_type == "2" ? (Number(totalProductPrice) * Number(offerdetails?.discount) / 100).toFixed(2) : Number(offerdetails?.discount || 0).toFixed(2)}
                                    </span>

                                  </div>
                                  <div className="savedBar   m-0 d-flex justify-content-between p-1 mt-1">
                                    <span className="fs-12 ff-poppins-medium">Total</span>
                                    <span className="fs-12 ff-poppins-medium">
                                      Rs.
                                      {
                                        offerdetails?.discount_type == "2"
                                          ? (Number(totalProductPrice) - (Number(totalProductPrice) * Number(offerdetails?.discount) / 100))?.toFixed(2)
                                          : (Number(totalProductPrice) - Number(offerdetails?.discount))?.toFixed(2)
                                      }
                                    </span>

                                  </div>
                                </div>
                              </div>
                            ) : offerdetails.applied_to == "1" ? (
                              <>
                                {
                                  offerdetails.applied_to_status.service_status == "1" &&
                                  <>
                                    <div className="d-flex justify-content-between align-items-center mt-4" onClick={togglestore}>

                                      <h6 className=" fs-15 ff-poppins-bold"> Store Services Included </h6>

                                      {showstore ? (
                                        <SlArrowUp className="me-2" />
                                      ) : (
                                        <SlArrowDown className="me-2" />
                                      )}
                                    </div>
                                    {/* service */}
                                    {showstore &&
                                      <>

                                        {storeservice.map((service, index) => {
                                          return (
                                            <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                              <span>{service.service_name}</span>
                                              <span>{service.service_price}.00</span>
                                            </div>
                                          );
                                        })}
                                        <div className="mt-3">
                                          <div className="offerServiceProduct border-top-Dashed">
                                            <span className="mt-1">Subtotal</span>
                                            <span className="mt-1">{totalServicePrice}.00 </span>
                                          </div>
                                          <div className="totalBar primary-text  fs-12 ff-poppins-medium d-flex justify-content-between   mt-1">
                                            {/* <span>Saved by offer(Rs{offerdetails.discount}.00 ) </span> */}

                                            <span className="mt-1 mb-1">
                                              Saved by offer ({
                                                offerdetails?.discount_type == "1" && <span className="rupeeIcon "> ₹</span>}
                                              {offerdetails?.discount}{offerdetails?.discount_type == "2" && "%"})
                                            </span>
                                            <span className="mt-1 mb-1">Rs.{savedAmount} </span>
                                          </div>
                                          <div className="savedBar m-0 d-flex justify-content-between mt-1">
                                            <span className="fs-12 mt-1 mb-1 ff-poppins-medium">Total </span>
                                            <span className="fs-12 mt-1 mb-1 ff-poppins-medium"> Rs.{finalPrice}</span>
                                          </div>
                                        </div>
                                      </>
                                    }
                                  </>
                                }
                                {
                                  offerdetails.applied_to_status.doorstep_status == "1" &&
                                  <div>
                                    <div className="d-flex justify-content-between align-items-center mt-4" onClick={toggledoorstep}>
                                      <h6 className="fs-15 ff-poppins-bold mb-0">Doorstep Services Included</h6>
                                      {showdoorstep ? (
                                        <SlArrowUp className="me-2" />
                                      ) : (
                                        <SlArrowDown className="me-2" />
                                      )}
                                    </div>

                                    {/* service */}
                                    {showdoorstep &&
                                      <>

                                        {doorstepservice.map((service, index) => {
                                          return (
                                            <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                              <span>{service.service_name}</span>
                                              <span>{service.doorstep_price}.00</span>
                                            </div>
                                          );
                                        })}
                                        <div className="mt-3">
                                          <div className="offerServiceProduct  border-top-Dashed">
                                            <span className="mt-1">Subtotal</span>
                                            <span className="mt-1">{totalDoorServicePrice}.00 </span>
                                          </div>
                                          <div className="totalBar primary-text  fs-12 ff-poppins-medium d-flex justify-content-between mb-1 mt-1">
                                            <span className="mt-1 mb-1">
                                              Saved by offer ({
                                                offerdetails?.discount_type == "1" && <span className="rupeeIcon "> ₹</span>}
                                              {offerdetails?.discount}{offerdetails?.discount_type == "2" && "%"})
                                            </span>
                                            <span className="mt-1 mb-1">Rs.{savedDoorAmt} </span>
                                          </div>
                                          <div className="savedBar m-0 d-flex justify-content-between mt-1">
                                            <span className="fs-12 mt-1 mb-1 ff-poppins-medium">Total </span>
                                            <span className="fs-12 mt-1 mb-1 ff-poppins-medium"> Rs.{finalDoorPrice} </span>
                                          </div>
                                        </div>
                                      </>
                                    }
                                  </div>
                                }
                              </>
                            ) : ""
                            : // BuyGet Offer

                            offerdetails?.offer_type == "3" &&
                              offerdetails.applied_to == "1" ? (
                              <div>
                                <h5 className="fs-14 ff-poppins-semiBold"> Buy Store Service{buyServices?.length > 1 ? 's' : ''} </h5>
                                {buyServices.map((buyser, index) => {
                                  return (
                                    <div className="offerServiceProduct">
                                      <span> {buyser.service_name}{" "} </span>
                                      <span> {buyser.service_price}.00</span>
                                    </div>
                                  );
                                })}
                                <div className="totalBar   m-0 d-flex justify-content-between  mt-3">
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total{" "} <span className="primary-text"> (Offer Price) </span>{" "} </span>
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1">Rs.{totalBuyservicePrice}.00</span>
                                </div>
                                <h5 className="fs-14 ff-poppins-semiBold mt-3"> Get Store Service{getServices.length > 1 ? 's' : ''} </h5>
                                {getServices.map((getser, index) => {
                                  return (
                                    <div className="offerServiceProduct">
                                      <span> {getser.service_name}{" "}</span>
                                      <span>{getser.service_price}.00</span>
                                    </div>
                                  );
                                })}
                                <div className="totalBar   m-0 d-flex justify-content-between  mt-3">
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total{" "} <span className="primary-text fs-12"> (Free Value) </span>{" "} </span>
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1">Rs.{totalGetservicePrice}.00</span>
                                </div>
                                {
                                  buydoorServices.length > 0 ?
                                    <div>
                                      <h5 className="fs-14 ff-poppins-semiBold mt-3"> Buy Doorstep Service{buydoorServices?.length > 1 ? 's' : ''} </h5>
                                      {buydoorServices.map((doorser, index) => {
                                        return (
                                          <div className=" offerServiceProduct ">
                                            <span> {doorser.service_name}{" "}</span>
                                            <span> {doorser.doorstep_price > 0 ? doorser.doorstep_price : "0"}.00 </span>
                                          </div>
                                        );
                                      })}
                                      <div className="totalBar m-0 d-flex justify-content-between  mt-3">
                                        <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total{" "} <span className="primary-text fs-12"> (Offer Price) </span>{" "} </span>
                                        <span className="fs-12 ff-poppins-medium mt-1 mb-1">Rs.{totalBuydoorservicePrice}.00 </span>
                                      </div>
                                    </div> : <></>
                                } {
                                  getdoorServices.length > 0 ?
                                    <div>
                                      <h5 className="fs-14 ff-poppins-semiBold mt-3"> Get Doorstep Service{getdoorServices?.length > 1 ? 's' : ''} </h5>
                                      {getdoorServices.map((getser, index) => {
                                        return (
                                          <div className="offerServiceProduct">
                                            <span>{getser.service_name}{" "} </span>
                                            <span>{getser.doorstep_price > 0 ? getser.doorstep_price : "0"}.00 </span>
                                          </div>
                                        );
                                      })}
                                      <div className="totalBar fs-13 m-0 d-flex justify-content-between  mt-3">
                                        <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total{" "} <span className="primary-text fs-12"> (Free Value) </span>{" "} </span>
                                        <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Rs.{totalGetdoorservicePrice}.00 </span>
                                      </div>
                                    </div>
                                    : <></>
                                } </div>
                            ) : offerdetails?.offer_type == "3" &&
                              offerdetails.applied_to == "2" ? (
                              <div>
                                <h5 className="fs-14 ff-poppins-semiBold"> Buy products </h5>
                                {buyProduct.map((buypro, index) => {
                                  return (
                                    <div className="d-flex justify-content-between col-12">
                                      <span className="p-0 m-0 fs-12 ff-poppins-regular ">{buypro.product_name} </span>
                                      <div className="col-4   offerServiceProduct">
                                        <span>{buypro.count}</span>
                                        <span> {buypro.product_price}.00 </span>
                                      </div>
                                    </div>
                                  );
                                })}
                                <div className="totalBar ff-poppins-regular d-flex justify-content-between  mt-3">
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total{" "} <span className="primary-text fs-12"> (Offer Price) </span>{" "} </span>
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1">Rs.{totalBuyProductPrice}.00</span>
                                </div>

                                <h5 className="fs-14 ff-poppins-semiBold mt-3"> Get products </h5>
                                {getProduct.map((getpro, index) => {
                                  return (
                                    <div className="d-flex justify-content-between fs-13">
                                      <span className=" ff-poppins-regular fs-12 p-0 m-0">{getpro.product_name} </span>
                                      <div className="col-4 offerServiceProduct">
                                        <span>{getpro.count}</span>
                                        <span> {getpro.product_price}.00 </span>
                                      </div>
                                    </div>
                                  );
                                })}
                                <div className="totalBar  d-flex justify-content-between p-1 mt-3">
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1"> Total <span className="primary-text fs-12"> (Free value) </span>{" "} </span>
                                  <span className="fs-12 ff-poppins-medium mt-1 mb-1">Rs.{totalGetProductPrice}.00</span>
                                </div>
                              </div>
                            ) : (
                              // pick any combo
                              offerdetails.offer_type == '4' ?
                                <div>

                                  <div>
                                    {((offerdetails?.applied_to == '1') || (offerdetails?.applied_to == '2,1') || (offerdetails?.applied_to == '1,2')) && (
                                      // <div>
                                      // <div className="d-flex justify-content-between mt-4 " onClick={togglestore}>
                                      // <h6 className="fs-15 ff-poppins-bold"> Store Services included </h6>
                                      // <div>
                                      // {showstore ? (
                                      // <SlArrowUp className="me-2" />
                                      // ) : (
                                      // <SlArrowDown className="me-2" />
                                      // )}
                                      // </div>
                                      // </div>
                                      // {/* Store modle */}
                                      // {showstore && (
                                      // storeservice.map((service, index) => (
                                      // <div className=' offerServiceProduct' key={index}>
                                      // <span>{service.service_name}</span>
                                      // <span>{service.service_price}.00</span>
                                      // </div>
                                      // ))
                                      // )}
                                      // {
                                      // offerdetails.delivery_status == '1' ?
                                      // <>
                                      // <div className="d-flex justify-content-between mt-4 " onClick={toggledoorstep}>
                                      // <h6 className=" fs-15 ff-poppins-bold"> Doorstep Services included </h6>
                                      // <div>
                                      // {showdoorstep ? (
                                      // <SlArrowUp className="me-2" />
                                      // ) : (
                                      // <SlArrowDown className="me-2" />
                                      // )}
                                      // </div>
                                      // </div>
                                      // {showdoorstep && (
                                      // doorstepservice.map((service, index) => (
                                      // <div className=' offerServiceProduct' key={index}>
                                      // <span >{service.service_name}</span>
                                      // <span >{service.doorstep_price}.00</span>
                                      // </div>
                                      // ))
                                      // )}
                                      // </>
                                      // : ""
                                      // }

                                      // </div>

                                      <>
                                        {
                                          offerdetails.applied_to_status.service_status == "1" &&
                                          <>
                                            <div className="d-flex justify-content-between align-items-center mt-4" onClick={togglestore}>
                                              <h6 className=" fs-15 ff-poppins-bold"> Store Services Included </h6>
                                              {showstore ? (<SlArrowUp className="me-2" />) : (<SlArrowDown className="me-2" />)}
                                            </div>
                                            {/* service */}
                                            {showstore &&
                                              <>
                                                {storeservice.map((service, index) => {
                                                  return (
                                                    <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                                      <span>{service.service_name}</span>
                                                      <span>{service.service_price}.00</span>
                                                    </div>
                                                  );
                                                })}
                                              </>
                                            }
                                          </>
                                        }
                                        {
                                          offerdetails.applied_to_status.doorstep_status == "1" &&
                                          <div>
                                            <div className="d-flex justify-content-between align-items-center mt-4" onClick={toggledoorstep}>
                                              <h6 className="fs-15 ff-poppins-bold mb-0">Doorstep Services Included</h6>
                                              {showdoorstep ? (
                                                <SlArrowUp className="me-2" />
                                              ) : (
                                                <SlArrowDown className="me-2" />
                                              )}
                                            </div>

                                            {showdoorstep &&
                                              <>
                                                {doorstepservice.map((service, index) => {
                                                  return (
                                                    <div className='d-flex justify-content-between mt-1 offerServiceProduct' key={index}>
                                                      <span>{service.service_name}</span>
                                                      <span>{service.doorstep_price}.00</span>
                                                    </div>
                                                  );
                                                })}
                                              </>
                                            }
                                          </div>
                                        }
                                      </>
                                    )}

                                    {(offerdetails?.applied_to == '2' || offerdetails?.applied_to == '2,1' || offerdetails?.applied_to == '1,2') && (
                                      <div>
                                        <div className="d-flex justify-content-between mt-4 " onClick={toggleproduct}>
                                          <h6 className=" fs-15 ff-poppins-bold"> Products </h6>
                                          <div>
                                            {showproduct ? (
                                              <SlArrowUp className="me-2" />
                                            ) : (
                                              <SlArrowDown className="me-2" />
                                            )}
                                          </div>
                                        </div>
                                        {showproduct && (
                                          product.map((item, index) => (
                                            <div className='  offerServiceProduct' key={index}>
                                              <span>{item.product_name}</span>
                                              <span>{item.product_price}.00</span>
                                            </div>
                                          ))
                                        )}
                                      </div>
                                    )}
                                  </div>

                                </div>
                                : ""
                            )
                      }

                      <hr></hr>
                      <div className="mt-4 mb-4">
                        {offerdetails?.offer_type == "1" || offerdetails?.offer_type == "2" ? (
                          <div className="fs-12 ff-poppins-regular">
                            <div>
                              Discount - {" "}
                              {offerdetails?.offer_type == "1" || offerdetails?.offer_type == "2" || offerdetails?.offer_type == "3" ? (
                                <span className="primary-text ff-poppins-medium">
                                  {offerdetails?.discount_type == "1" && <span className="rupeeIcon "> ₹</span>}{offerdetails?.discount}
                                  <span>
                                    {offerdetails?.discount_type == "2" ? (
                                      "%"
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                </span>
                              ) : (
                                <></>
                              )}{" "}
                              {offerdetails?.min_pur_status == 1 &&
                                <div className="mt-1">
                                  Minimum purchase value - {" "}
                                  <span className="primary-text ff-poppins-medium">
                                    <span className="rupeeIcon "> ₹</span>{offerdetails?.min_pur_amount}
                                  </span>
                                </div>
                              }
                              {offerdetails?.min_qty_status == 1 &&
                                <div className="mt-1">
                                  Minimum purchase quantity - {" "}

                                  <span className="primary-text ff-poppins-medium"> {offerdetails?.min_quantity} </span>

                                </div>
                              }

                            </div>

                          </div>
                        ) : (
                          offerdetails?.offer_type == "4" ?
                            <div className="fs-14 ff-poppins-regular">
                              <p className="p-0 m-0 fs-12 ff-poppins-regular">Combo Count - {" "} <span className="primary-text m-0">{offerdetails.combo_count}</span> </p>
                              <p className="p-0 m-0 fs-12 ff-poppins-regular mt-1 mb-1">Offer Price - {" "} <span className="primary-text m-0"><span className="rupeeIcon "> ₹</span>{offerdetails.offer_price}</span> </p>
                            </div>
                            : ""
                        )}

                        <div className="fs-12 mt-1 ff-poppins-regular">
                          <span >Expiry Date - </span>
                          {/* <span className="primary-text">
														{offerdetails?.duration
															? new Date(offerdetails.duration).toDateString().substring(4, 15)
															: 'N/A'}
													</span> */}
                          <span className="primary-text">
                            {offerdetails?.duration
                              ? new Date(offerdetails.duration).toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              }).replace(/(\d{2}) (\w{3})/, "$2 $1,") // ensures format like "Oct 31, 2025"
                              : 'N/A'}
                          </span>
                        </div>

                      </div>

                      <div className="col-12 ps-1 pe-1 mt-4 SPCard">
                        <div className="d-flex justify-content-between ">

                          <div className="d-flex col-9" onClick={() => navigate(`/vendor/${vendor.vendor_id}`)}>
                            <img className="rounded-3 ms-1" src={vendor?.vendor_logo} width={'70px'} height={'70px'} />
                            <div className="ms-2">
                              <div className="ff-poppins-semiBold fs-14 ms-1"> {" "} {vendor?.vendor_company_name}</div>
                              <div className="ff-poppins-medium fs-11 text-secondary">&#x2022; MID {vendor?.vendor_id} </div>
                              <div className="ff-poppins-medium fs-11 text-secondary">&#x2022; {vendor?.vendor_type_name} </div>
                              <div className="ff-poppins-medium fs-11 text-secondary singleline-text">&#x2022; {vendor?.vendor_address} </div>
                            </div>
                          </div>

                          <div className="col-3">
                            <div className="d-flex justify-content-center align-items-center ">
                              <div className='text-center mapIcons ps-4 me-3 mt-2' role='button' onClick={() => openMap(vendor?.vendor_lat, vendor?.vendor_long)}>
                                <img src={p_vendor_map} className="d-block mt-2" alt="map" width={'25px'} height={'30px'} />
                                <div className='ff-poppins-medium fs-13 primary-text mt-1'>MAP</div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="mt-4">
                        <h5 className="fs-14 ff-poppins-semiBold"> Availability </h5>
                        <p className="fs-12 ff-poppins-regular secoudary-text">Offer is available on the following days and hours</p>
                      </div>
                      <div className="availbilitybox p-3">
                        <h5 className="fs-14 ff-poppins-semiBold">Available Hours</h5>
                        {offertime.map((time, subindex) => {
                          return (
                            <div className="d-flex justify-content-between p-2 fs-14 ff-poppins-regular">
                              <p className="p-0 fs-12 ff-poppins-regular primary-text m-0">{time.day} </p>
                              <p className="p-0 fs-12 ff-poppins-regular m-0">{time.timing} </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="p-2 ">
              <h6 className="fs-12 ms-1 ff-poppins-semiBold ">Offer Terms & Conditions</h6>

              <div className="ff-poppins-regular fs-11"><GoDotFill /> Offer Valid Until {offerdetails?.duration ? new Date(offerdetails.duration).toDateString().substring(4, 15) : 'N/A'}</div>
              <div className="ff-poppins-regular fs-11"><GoDotFill /> Limit {offerdetails.usage_limit_per_user} use(S) per user </div>
              {offerdetails?.terms_and_conditions?.trim() && (
                <div className="d-flex">
                  <span className="ff-poppins-regular fs-11">
                    <GoDotFill />
                  </span>

                  <div className="ms-1 ">
                    {offerdetails?.terms_and_conditions
                      .split("\n")
                      .map((line, index) => (
                        <p
                          key={index}
                          className="fs-12 p-0 m-0 ff-poppins-regular mb-1"
                        >
                          {line.trim()}
                        </p>
                      ))}
                  </div>
                  {/* <p
										className="fs-10 ff-poppins-regular ms-1"
										dangerouslySetInnerHTML={{
											__html: offerdetails?.terms_and_conditions?.replace(/\n/g, "<br/>")
										}}
									></p> */}
                </div>
              )}




            </div>

            <div className="p-2 booknowBtn" >
              <button className="offerBookNowBtn"
                onClick={() => handelNavigate(1)}>
                Book Now
              </button>
            </div>
          </div>
        </div>

      ) : (
        <div className=" ReactLoading">
          <ReactLoading type={"spinningBubbles"} color={"#4E26A3"} />
        </div>
      )
      }



      {
        modalOpen && (
          <div className="modal fade show successModal bg-white" tabIndex="-1" >
            <div className="modal-dialog modal-dialog-centered modal-sm m-0">
              <div className="modal-content">
                <div className="modal-body ps-3 pe-3 pt-4 pb-4">
                  <div className='text-center ff-poppins-medium fs-12'>{modalMgs}</div>

                  <div className="d-flex justify-content-center mt-3">
                    <button type="button" className="col-5 ouline-none border-none rounded-3 primary-bg text-light p-2 ff-poppins-medium fs-13" onClick={() => handelNavigate(2)} >Click here</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
};
export default Singleofferdetails;





